const eurToUsd = 1.16;
const tonToSHortTon = 1.1023;
const kgToLb = 2.2046;
const m3toGal = 264.172;
const fToM= 0.3048;
const m2ToFt2 = 10.764

export function convertUsdPerTonShortToEurPerTon(value) {
  if (!value) return value;

  return value * (tonToSHortTon / eurToUsd);
}

export function convertEurPerTonToUsdPerTonShort(value) {
  if (!value) return value;

  return value * (eurToUsd / tonToSHortTon);
}

export function convertLbToKG(value) {
  if (!value) return value;
  return value / kgToLb;
}

export function convertKgToLb(value) {
  if (!value) return value;
  return value * kgToLb;
}

export function convertUsdToEur(value) {
  if (!value) return value;
  return value / eurToUsd;
}

export function convertEurToUsd(value) {
  if (!value) return value;
  return value * eurToUsd;
}

export function convertUsdPerMilGalToEuroPerM3(value) {
  if (!value) return value;
  return value /( (eurToUsd / m3toGal) * Math.pow( 10, 6));
}

export function convertEuroPerM3ToUsdPerMilGal(value) {
  if (!value) return value;
  return value * (eurToUsd / m3toGal) * Math.pow(10, 6);
}

export function convertFtoC(value) {
  if (value === null) return value;
  return (value - 32) / (9 / 5);
}

export function convertCtoF(value) {
  if (value === null) return value;
  return (value * 9) / 5 + 32;
}

export function convertTonToTonShort(value) {
  if (!value) return value;
  return value * tonToSHortTon;
}

export function convertM3ToMGal(value) {
  if (!value) return value;
  return (value * m3toGal) / 1000000;
}

export function convertFtToM(value){
  if (value === null) return value;
  return value / (1 / fToM);
}

export function convertMToFt(value){
  if (value === null) return value;
  return value * (1 / fToM);
}

export function convertLbPer1000ft2toKgPerM2(value){
  if (value === null) return value;
  return value * m2ToFt2 / kgToLb;
}

export function convertKgPerM2toLbPer1000ft2(value){
  if (value === null) return value;
  return value / (m2ToFt2 / kgToLb);
}